// Build-time configuration (override with VITE_* env vars).

export const SITE_URL = (import.meta.env?.VITE_SITE_URL || "http://localhost:4321").replace(/\/$/, "");

// Marketing-site legal page slugs, keyed by the API's terms document ids.
export const LEGAL_SLUGS = { tos: "terms", aup: "acceptable-use", dpa: "dpa" };

export const legalUrl = (doc, locale) => `${SITE_URL}/${locale}/legal/${LEGAL_SLUGS[doc]}`;

export const PURPOSES = [
  "security_assessment",
  "due_diligence",
  "fraud_investigation",
  "journalism",
  "legal_proceedings",
  "other",
];

export const STAGES = ["policy", "normalize", "enumerate", "extract", "enrich", "validate", "correlate"];

export const NODE_TYPES = [
  "domain",
  "subdomain",
  "ip",
  "nameserver",
  "mailserver",
  "organisation",
  "network",
  "certificate",
];

export const FINDING_TYPES = [
  "subdomain",
  "dns_record",
  "ip",
  "nameserver",
  "mx",
  "registration",
  "network",
  "certificate",
  "http_service",
  "ptr",
];

export const INVITE_ROLES = ["admin", "analyst", "viewer"];

// Polling intervals (ms)
export const TASKS_POLL_MS = 10000;
export const JOB_POLL_MS = 2500;
